import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/views/Login'
import Signup from '@/views/Signup'
import StepOne from '@/views/StepOne'
import StepTwo from '@/views/StepTwo'
import StepThree from '@/views/StepThree'
import LastStep from '@/views/LastStep'
import MyXsensibles from '@/views/MyXsensibles'

import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/signup',
    component: Signup,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/step-1',
    component: StepOne,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/step-2',
    component: StepTwo,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/step-3',
    component: StepThree,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/last-step',
    component: LastStep,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/my-xsensibles',
    component: MyXsensibles,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const authUser = localStorage.getItem('authUser')
    if (!authUser) {
      next({
        path: '/login'
      })
    } else {
      const { userId, sessionId } = JSON.parse(authUser)
      if (userId && sessionId) {
        store.commit('setAuth', { userId, sessionId })
      }
      next()
    }
  } else {
    next()
  }
})

export default router
